<div class="heatmap-v2-wrap">
  <svg
    [attr.viewBox]="'0 0 ' + svgWidth + ' ' + svgHeight"
    width="100%"
    role="img"
    [attr.aria-label]="'Matriz ' + axisYLabel + ' × ' + axisXLabel">

    <!-- Zonas de isoriesgo -->
    @for (zone of zonePaths; track zone.color) {
      <path [attr.d]="zone.d" [attr.fill]="zone.color" opacity="0.14"/>
    }

    <!-- Fronteras entre zonas (líneas punteadas) -->
    @for (border of borderPaths; track $index) {
      <path
        [attr.d]="border"
        fill="none"
        stroke="rgba(28,27,34,0.16)"
        stroke-width="1"
        stroke-dasharray="3 4"
        vector-effect="non-scaling-stroke"/>
    }

    <!-- Ejes -->
    <line
      [attr.x1]="margin.l" [attr.y1]="margin.t + svgHeight - margin.t - margin.b"
      [attr.x2]="margin.l + svgWidth - margin.l - margin.r" [attr.y2]="margin.t + svgHeight - margin.t - margin.b"
      stroke="rgba(28,27,34,0.35)"/>
    <line
      [attr.x1]="margin.l" [attr.y1]="margin.t"
      [attr.x2]="margin.l" [attr.y2]="margin.t + svgHeight - margin.t - margin.b"
      stroke="rgba(28,27,34,0.35)"/>

    <!-- Ticks eje X -->
    @for (tick of axisTicks; track tick) {
      <text
        [attr.x]="svgTickX(tick)"
        [attr.y]="margin.t + svgHeight - margin.t - margin.b + 18"
        text-anchor="middle"
        class="heatmap-v2-tick">{{ tick }}</text>
    }

    <!-- Ticks eje Y -->
    @for (tick of axisTicks; track tick) {
      <text
        [attr.x]="margin.l - 9"
        [attr.y]="svgTickY(tick) + 4"
        text-anchor="end"
        class="heatmap-v2-tick">{{ tick }}</text>
    }

    <!-- Etiqueta eje X -->
    <text
      [attr.x]="margin.l + (svgWidth - margin.l - margin.r) / 2"
      [attr.y]="svgHeight - 8"
      text-anchor="middle"
      class="heatmap-v2-axis-label">{{ axisXLabel }}</text>

    <!-- Etiqueta eje Y -->
    <text
      x="14"
      [attr.y]="margin.t + (svgHeight - margin.t - margin.b) / 2"
      text-anchor="middle"
      class="heatmap-v2-axis-label"
      [attr.transform]="'rotate(-90 14 ' + (margin.t + (svgHeight - margin.t - margin.b) / 2) + ')'">{{ axisYLabel }}</text>

    <!-- Puntos -->
    @for (pt of renderedPoints; track pt.key) {
      <g>
        <title>{{ pt.tooltip }}</title>

        <!-- Línea vertical inherente → residual -->
        @if (pt.cyRes !== null && showInherited && showResidual) {
          <line
            [attr.x1]="pt.cx" [attr.x2]="pt.cx"
            [attr.y1]="pt.cyInh" [attr.y2]="pt.cyRes"
            stroke="rgba(28,27,34,0.35)"
            stroke-width="1.4"
            vector-effect="non-scaling-stroke"/>
        }

        <!-- Anillo hueco: inherente -->
        @if (showInherited) {
          <circle [attr.cx]="pt.cx" [attr.cy]="pt.cyInh" r="8" fill="white" opacity="0.85"/>
          <circle
            [attr.cx]="pt.cx" [attr.cy]="pt.cyInh"
            r="6" fill="white"
            [attr.stroke]="pt.color"
            stroke-width="2"/>
        }

        <!-- Círculo sólido: residual -->
        @if (showResidual && pt.cyRes !== null) {
          <circle [attr.cx]="pt.cx" [attr.cy]="pt.cyRes" r="8" fill="white" opacity="0.85"/>
          <circle
            [attr.cx]="pt.cx" [attr.cy]="pt.cyRes"
            r="5.5"
            [attr.fill]="pt.color"/>
        }

        <!-- Etiqueta con halo -->
        @if (pt.label) {
          <text
            [attr.x]="pt.labelX"
            [attr.y]="pt.labelY"
            [attr.text-anchor]="pt.textAnchor"
            class="heatmap-v2-label">{{ pt.label }}</text>
        }
      </g>
    }
  </svg>

  <!-- Leyenda de niveles -->
  <div class="heatmap-v2-legend">
    @for (level of riskLevels; track level.label) {
      <div
        class="level-chip"
        [style.background]="level.bg"
        [style.color]="level.textColor">
        <span [style.background]="level.color"></span>
        <strong>{{ level.label }}</strong>
        <small>{{ level.range }}</small>
      </div>
    }
  </div>
</div>
